"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r = n(e),
    _o = function o() {
  return (_o = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var o in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    i = function i() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M12.5 4.5L12.5 19.5"
  }), r.createElement("path", {
    d: "M18 10L12.5 4.5 7 10"
  }), r.createElement("path", {
    d: "M17.5.5h5a1,1,0,0,1,1,1v21a1,1,0,0,1-1,1h-5"
  }), r.createElement("path", {
    d: "M6.5.5h-5a1,1,0,0,0-1,1v21a1,1,0,0,0,1,1h5"
  }));
},
    c = {
  left: 0,
  top: 8
},
    a = function a(e) {
  var n = e.onClick,
      o = r.useContext(t.LocalizationContext),
      a = o && o.open ? o.open.openFile : "Open file",
      l = r.createRef();
  return r.createElement(t.Tooltip, {
    ariaControlsSuffix: "open",
    position: t.Position.BottomCenter,
    target: r.createElement("div", {
      className: "rpv-open__input-wrapper"
    }, r.createElement("input", {
      ref: l,
      className: "rpv-open__input",
      multiple: !1,
      tabIndex: -1,
      title: "",
      type: "file",
      onChange: n
    }), r.createElement(t.MinimalButton, {
      ariaLabel: a,
      onClick: function onClick() {
        var e = l.current;
        e && e.click();
      }
    }, r.createElement(i, null))),
    content: function content() {
      return a;
    },
    offset: c
  });
},
    l = function l(e) {
  var t = e.store;
  return (e.children || function (e) {
    return r.createElement(a, {
      onClick: e.onClick
    });
  })({
    onClick: function onClick(e) {
      var n = e.target.files;

      if (n && n.length) {
        var r = t.get("openFile");
        r && r(n[0]);
      }
    }
  });
},
    u = function u(e) {
  var n = e.onClick,
      o = r.useContext(t.LocalizationContext),
      c = o && o.open ? o.open.openFile : "Open file",
      a = r.createRef();
  return r.createElement(t.MenuItem, {
    icon: r.createElement(i, null),
    onClick: function onClick() {
      var e = a.current;
      e && e.click();
    }
  }, r.createElement("div", {
    className: "rpv-open__input-wrapper"
  }, r.createElement("input", {
    ref: a,
    className: "rpv-open__input",
    multiple: !1,
    tabIndex: -1,
    title: "",
    type: "file",
    onChange: n
  }), c));
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


exports.OpenFileIcon = i, exports.openPlugin = function () {
  var e = r.useMemo(function () {
    return t.createStore({});
  }, []),
      n = function n(t) {
    return r.createElement(l, _o({}, t, {
      store: e
    }));
  };

  return {
    install: function install(t) {
      e.update("openFile", t.openFile);
    },
    Open: n,
    OpenButton: function OpenButton() {
      return r.createElement(n, null);
    },
    OpenMenuItem: function OpenMenuItem() {
      return r.createElement(n, null, function (e) {
        return r.createElement(u, {
          onClick: e.onClick
        });
      });
    }
  };
};